import React from 'react';
import './StepIndicator.css';

interface Step {
  number: number;
  title: string;
}

interface Props {
  steps: Step[];
  currentStep: number;
}

const StepIndicator: React.FC<Props> = ({ steps, currentStep }) => {
  return (
    <div className="step-indicator">
      {steps.map((step, index) => {
        const isActive = step.number === currentStep;
        const isCompleted = step.number < currentStep;
        const isLast = index === steps.length - 1;

        return (
          <div key={step.number} className="step-indicator-item-wrapper">
            <div className={`step-indicator-item ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}>
              <div className="step-indicator-circle">
                {isCompleted ? (
                  <span className="step-indicator-check">✓</span>
                ) : (
                  <span className="step-indicator-number">{step.number}</span>
                )}
              </div>
              <span className="step-indicator-title">{step.title}</span>
            </div>
            {!isLast && (
              <div className={`step-indicator-line ${isCompleted ? 'completed' : ''}`} />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default StepIndicator;
